import { UserEditPage } from "@features/security/components/UserEditPage";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";

/**
 * Security — User Edit Route
 *
 * Form to edit an existing user (info, profile, direct/effective permissions).
 * Access requires security.users.edit permission.
 */
export const Route = createFileRoute("/_app/admin/users/$id/edit")({
  loader: requirePermission(PERMISSIONS.SECURITY.USERS.EDIT),
  staticData: {
    title: "Modifier utilisateur",
    permission: PERMISSIONS.SECURITY.USERS.EDIT,
    showInBreadcrumb: true,
  },
  component: UserEditPage,
});
